import { Link } from "react-router-dom";

export function ImportExpensesHelp() {
  return (
    <div>
      <div className="max-w-5xl min-h-screen mx-auto px-5">
        <div className="my-10">
          <Link
            to={"/help"}
            className="text-sm text-blue-500 underline flex mb-4"
          >
            Back To Help
          </Link>
          <h2 className="text-3xl font-bold">Import Expenses</h2>
        </div>

        <div>
          <p>
            You can upload <strong>unlimited</strong> number of expenses under
            any subscription.
          </p>

          <hr />

          <div id="bulk">
            <h3 className="my-4 font-bold text-xl">
              Upload Transactions From CSV
            </h3>
            <p>
              Please make sure your CSV contains the following columns. All
              columns are <strong className="text-red-500">mandatory</strong>,
              but can be in any order.
            </p>

            <div className="my-10">
              <img
                src="/assets/images/import-expenses.png"
                style={{ width: "80%" }}
                alt="import-expenses-csv-example"
              />
            </div>

            <strong>To import expenses</strong>
            <ul className="disc" style={{ lineHeight: 2 }}>
              <li>Login to the app</li>
              <li>Choose your group.</li>
              <li>
                Click <strong>Add Expense</strong> in the home page.
              </li>
              <li>
                Click on <strong>Upload from CSV</strong> from top right corner
              </li>
              <li>Upload your CSV and hit ok.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
